import React from 'react';
import { SteppedProcessProvider } from './context';
import { SteppedProcessBase } from './SteppedProcessBase';
const SteppedProcess = ({ steps, variant, a11y, initialState, }) => {
    const initialStepState = (stepIndex) => {
        var _a;
        const foundIndex = (_a = initialState === null || initialState === void 0 ? void 0 : initialState.completedStepIndices) === null || _a === void 0 ? void 0 : _a.find(completedIndex => stepIndex === completedIndex);
        return typeof foundIndex === 'number' ? 'complete' : 'incomplete';
    };
    const initializedStepsMetadata = steps.length
        ? steps.map((step, index) => ({
            id: step.id,
            index,
            title: step.title.text,
            state: initialStepState(index),
        }))
        : [];
    return (React.createElement(SteppedProcessProvider, { initialActiveStepIndex: (initialState === null || initialState === void 0 ? void 0 : initialState.activeStepIndex) !== undefined
            ? initialState === null || initialState === void 0 ? void 0 : initialState.activeStepIndex
            : 0, initialStepsMetadata: initializedStepsMetadata }, steps.length && (React.createElement(SteppedProcessBase, { steps: steps, variant: variant, a11y: a11y }))));
};
export { SteppedProcess };
//# sourceMappingURL=SteppedProcess.js.map